// Generated by scripts/build-ui-icons.mjs.
export { HeartSelected as default } from "../ui/selected";
